export default __webpack_public_path__ + "static/media/lunch3.d5e0215b.jpeg";